export const PaymentConfig = {
    // Public Client Keys (Safe to expose)
    // REPLACE THESE with your actual Toss Payments Client Keys
    TEST_CLIENT_KEY: "test_ck_ORzdMaqN3wP69dp6QpagV5AkYXQG",
    LIVE_CLIENT_KEY: null, // [GOVERNANCE] LIVE KEY는 Admin Dashboard → DB로 관리. 이 파일에 저장 금지.

    // Helper to get key by mode
    getKey: (mode) => {
        return mode === 'LIVE'
            ? PaymentConfig.LIVE_CLIENT_KEY
            : PaymentConfig.TEST_CLIENT_KEY;
    }
};
